<template>
    <div class="confirmOrder">
        <CustomHeader leftText="确认订单" />
        <div class="confirmOrder-wrap">
            <div class="process">
                <div>
                    <icon-bed />
                    <div>1.选择房型并预订</div>
                </div>
                <div>
                    <icon-wait-confirm />
                    <div>2.静待商家接单确认</div>
                </div>
                <div>
                    <icon-complete />
                    <div>3.预订成功/失败</div>
                </div>
            </div>
            <div class="hotelInfo flex-column">
                <div class="date-info jc-between ai-center">
                    <div class="dateArea jc-between ai-center flex-1">
                        <div @click="clickDate('start')" class="startTime clickOuterActive">
                            <span>{{ routeQuery.startTime | toNumCNDate }}</span>
                            <span>{{ routeQuery.startTime | toCNWeek }}</span>
                        </div>
                        <div>{{ dataLength }}晚</div>
                        <div @click="clickDate('end')" class="endTime clickOuterActive">
                            <span>{{ routeQuery.endTime | toNumCNDate }}</span>
                            <span>{{ routeQuery.endTime | toCNWeek }}</span>
                        </div>
                    </div>
                    <div @click="clickPersonNum" class="personNum jc-end clickOuterActive">{{ routeQuery.personNum }}人</div>
                </div>
                <div class="roomTitle">
                    <div>{{ roomDetail.hotelId.hotelName }}</div>
                    <span>{{ roomDetail.name }}</span>
                </div>
                <div class="facility jc-between flex-wrap">
                    <div class="facilityItem" v-for="(item, index) in roomDetail.hotelId.description.facilityShow" :key="index">
                        <span style="margin-top: 0.6vw;" :class="`c-darkgrey fa fa-fw ${item.icon}`" />
                        <span @click="$toast(item.text)">{{ item.text }}</span>
                    </div>
                    <!-- <div class="facilityItem" v-for="item in 1" :key="item + 999"></div> -->
                </div>
            </div>

            <div class="notice">
                <div class="jc-between line1">
                    <div class="ai-center">
                        <icon-warn size="5vw" />
                        <span>订房必读</span>
                    </div>
                    <div @click="showFindAll = true">
                        查看全部 >
                    </div>
                </div>
                <!-- <div>
                    <ul>
                        <li v-for="(item, index) in roomDetail.mustRead.map(item1 => item1.content)" :key="index">
                            {{ item }}
                        </li>
                    </ul>
                </div> -->
            </div>

            <div class="roomInfo">
                <van-cell title="入住人信息" value="" />
                <van-form style="padding-bottom: 10px;">
                    <div class="roomNum">
                        <van-cell
                            title="房间数量"
                            @click="arrowDir = arrowDir == 'up' ? 'down' : 'up'"
                            is-link
                            :arrow-direction="arrowDir"
                            :value="`${routeQuery.roomNum}间（每间最多住2人）`"
                        />
                        <div :class="{ collapsedPicker: arrowDir == 'down' }" class="roomNumPicker jc-evenly ai-center">
                            <div
                                @click="selectRoomNum(index)"
                                class="flex-center"
                                :class="{ activeItem: item.active }"
                                v-for="(item, index) in roomNums"
                                :key="index"
                            >
                                {{ index + 1 }}
                            </div>
                        </div>
                    </div>
                    <van-field
                        v-for="(item, index) in cusNames"
                        :key="index"
                        v-model="cusNames[index]"
                        :name="`room${index + 1}`"
                        :label="`房间${index + 1}`"
                        placeholder="每间填1位住客姓名"
                    />
                    <van-field v-model="routeQuery.mobile" name="mobile" placeholder="请输入联系手机号">
                        <template #label>
                            <div class="height-100 ai-center">联系手机</div>
                        </template>
                        <template #input>
                            {{ mobile }}
                            <!-- <div @click="showCountryCodePop = true" style="padding: 0 1vw;" class="jc-between ai-center clickActive">
                                {{ currentCountryCode }}<van-icon class="ai-center" style="margin-left: 1vw;min-height:24px;" name="arrow-down" />
                            </div>
                            <input
                                placeholder="请输入手机号"
                                maxlength="11"
                                onkeyup="this.value=this.value.replace(/\D/g,'')"
                                class="clearInput"
                                type="text"
                                v-model="mobile"
                            /> -->
                        </template>
                    </van-field>
                </van-form>
            </div>

            <div class="importantNotice" v-if="roomDetail.hint">
                <van-cell title="重要提醒" value="" />
                <div class="iNItem">
                    <van-cell class="iNItemText">
                        <div v-html="roomDetail.hint.content"></div>
                    </van-cell>
                </div>
            </div>
        </div>
        <div class="submitSheet jc-between ai-center">
            <div>
                <span>合计：</span>
                <span>{{ reserveTime }}次</span>
            </div>
            <van-button @click="toSuccess" size="small" color="linear-gradient(90deg,#fde59f,#ebb06c)"><div class="submitBtn">提交预订</div></van-button>
        </div>
        <van-popup v-model="showFindAll" position="bottom" :style="{ height: '40%' }">
            <div class="noticePopTitle flex-center">
                <div class="flex-center">订房必读</div>
                <div @click="showFindAll = false" class="flex-center">
                    <van-icon name="cross" />
                </div>
            </div>
            <div style="height: calc(100% - 10vw);overflow-y: scroll;margin-top: 10vw;">
                <!-- <div v-for="(item, index) in roomDetail.mustRead" :key="index" class="noticeItem jc-between">
                    <div>{{ item.title }}</div>
                    <div>{{ item.content }}</div>
                </div> -->
                <div v-html="roomDetail.policy ? roomDetail.policy.content : ''"></div>
            </div>
        </van-popup>

        <van-popup v-model="showCountryCodePop" round position="bottom" style="height: 80%;">
            <div class="noticePopTitle flex-center">
                <div class="flex-center">选择手机区号</div>
                <div @click="showCountryCodePop = false" class="flex-center">
                    <van-icon name="cross" />
                </div>
            </div>
            <div style="height: calc(100% - 10vw);overflow-y: scroll;margin-top: 10vw;">
                <van-index-bar>
                    <div v-for="(item, index) in countryCodes" :key="index">
                        <van-index-anchor :index="item.label">{{ item.label }}</van-index-anchor>
                        <van-cell
                            class="clickActive"
                            @click="clickIndexBarItem(item1)"
                            v-for="(item1, index1) in item.countryList"
                            :key="index1"
                            :title="`+${item1.code}  ${item1.zh}`"
                        />
                    </div>
                </van-index-bar>
            </div>
        </van-popup>

        <van-popup v-model="showDatePicker" round position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                @cancel="showDatePicker = false"
                @confirm="confirmDate"
                type="date"
                :title="`${dateType == 'start' ? '请选择入住时间' : '请选择离店日期'}`"
                :min-date="minDate"
                :max-date="maxDate"
            />
        </van-popup>

        <van-popup v-model="showPersonNumPicker" round position="bottom" :style="{ height: '50%' }">
            <van-picker
                ref="personNumRef"
                title="请选择入住人数"
                @cancel="showPersonNumPicker = false"
                @confirm="confirmPersonNumPicker"
                show-toolbar
                :columns="new Array(5).fill(null).map((item, index) => ({ text: index + 1 + '人', value: index + 1 }))"
            />
        </van-popup>
    </div>
</template>
<script>
import { searchParamsKey, msUserInfo } from "@/utils/variable";
import countryCodes from "@/utils/countryCode";
import { getRoomDetail, orderBuy } from "@/api/hotel";
const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
let initRouteQuery = {
    startTime: today,
    endTime: today + 1000 * 60 * 60 * 24,
    selectedKeyword: "",
    selectedStar: {
        index: -1,
        title: "星级/价格",
    },
    selectedAreaObj: {
        code: null,
        name: "请选择城市",
    },
    personNum: 1,
    roomNum: 1,
    hotelName: "",
    roomName: "",
    fuzzySearch: "",
};
export default {
    data() {
        return {
            routeQuery: JSON.parse(JSON.stringify(initRouteQuery)),
            showFindAll: false,
            showCountryCodePop: false,
            arrowDir: "down",
            roomNums: new Array(5).fill(null).map(item => ({ active: false })),
            cusNames: [""],
            countryCodes,
            currentCountryCode: "86",
            showDatePicker: false,
            minDate: new Date(today),
            maxDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
            dateType: "start",
            currentDate: new Date(today),
            showPersonNumPicker: false,
            roomDetail: { hotelId: { description: { facilityShow: [] } }, facility: [], mustRead: [], hint: {} },
            mobile: null,
        };
    },
    computed: {
        dataLength() {
            return `${Math.floor(
                (new Date(this.routeQuery.endTime).getTime() - new Date(this.routeQuery.startTime).getTime()) / (1000 * 60 * 60 * 24)
            )}`;
        },
        reserveTime() {
            return this.dataLength * this.cusNames.length;
        },
    },
    watch: {
        cusNames: {
            handler(newV) {
                this.routeQuery.cusNames = newV;
            },
            immediate: true,
        },
        currentCountryCode: {
            handler(newV) {
                this.routeQuery.currentCountryCode = newV;
            },
            immediate: true,
        },
    },
    created() {
        this.initPage();
    },
    methods: {
        initPage() {
            this.routeQuery = localStorage[searchParamsKey] ? JSON.parse(localStorage[searchParamsKey]) : JSON.parse(JSON.stringify(initRouteQuery));
            this.routeQuery.roomNum ? false : (this.routeQuery.roomNum = 1);
            this.roomNums[this.routeQuery.roomNum - 1].active = true;
            this.cusNames = new Array(this.routeQuery.roomNum).fill("").map(item => "");
            this.mobile = localStorage[msUserInfo] ? JSON.parse(localStorage[msUserInfo]).mobile : "";
            console.log(this.mobile);
            let roomId = this.$route.query.roomId;
            if (roomId) {
                getRoomDetail({ id: roomId }).then(res => {
                    if (res.code === 200) {
                        this.roomDetail = {
                            ...res.data,
                            // facility: (JSON.parse(res.data.facility) || []).map(item => ({
                            //     icon: item.split("&name=")[0],
                            //     text: item.split("&name=")[1],
                            // })),
                            hotelId: res.data.hotelId
                                ? {
                                      ...res.data.hotelId,
                                      description: res.data.hotelId.description
                                          ? {
                                                ...JSON.parse(res.data.hotelId.description),
                                                facilityShow: JSON.parse(res.data.hotelId.description).facilityShow.map(item => ({
                                                    icon: item.split("&name=")[0],
                                                    text: item.split("&name=")[1],
                                                })),
                                            }
                                          : { facilityShow: [] },
                                  }
                                : { description: { facilityShow: [] } },
                            mustRead: res.data.mustRead ? JSON.parse(res.data.mustRead) || [] : "",
                            // policy: res.data.policy ? res.data.policy : { content: "" },
                        };
                    }
                });
            }
        },
        clickPersonNum() {
            this.showPersonNumPicker = true;
            this.$nextTick(() => {
                this.$refs.personNumRef.setIndexes([this.routeQuery.personNum - 1]);
            });
        },
        confirmPersonNumPicker(e) {
            this.routeQuery.personNum = e.value;
            this.showPersonNumPicker = false;
        },
        confirmDate(e) {
            let DateTime = e.getTime();
            if (this.dateType == "start") {
                if (this.routeQuery.endTime - DateTime >= 1000 * 60 * 60 * 24) {
                    this.routeQuery.startTime = DateTime;
                } else {
                    return this.$toast("开始时间应小于结束时间");
                }
            } else {
                if (DateTime - this.routeQuery.startTime >= 1000 * 60 * 60 * 24) {
                    this.routeQuery.endTime = DateTime;
                } else {
                    return this.$toast("结束时间应大于开始时间");
                }
            }
            this.showDatePicker = false;
        },
        clickDate(type) {
            this.showDatePicker = true;
            this.dateType = type;
            if (type == "start") {
                this.currentDate = new Date(this.routeQuery.startTime);
            } else {
                this.currentDate = new Date(this.routeQuery.endTime);
            }
        },
        clickIndexBarItem(item) {
            this.currentCountryCode = item.code;
            this.showCountryCodePop = false;
        },
        toSuccess() {
            this.$toast({ duration: 0, message: "提交中", forbidClick: true });
            let canSubmit = true;
            this.cusNames.some((item, index) => {
                if (!item) {
                    this.$toast(`请填写房间${index + 1}对应的住户姓名`);
                    canSubmit = false;
                    return true;
                }
            });
            // this.mobile = 17607101164;
            if (!canSubmit) return false;
            canSubmit = /^1[3456789]\d{9}$/.test(this.mobile);
            if (!canSubmit) {
                this.$toast("请输入11位数手机号");
                return false;
            }
            let orderParams = {
                hotelId: this.$route.query.hotelId,
                roomId: this.$route.query.roomId,
                liveCount: this.dataLength,
                mobile: this.mobile,
                remark: "",
                residents: this.cusNames.join(","),
                roomCount: this.cusNames.length,
                startLiveTime: this.routeQuery.startTime + 1000 * 60 * 60 * 12,
            };
            orderBuy(orderParams)
                .then(res => {
                    this.$toast.clear();
                    if (res.code === 200) {
                        this.$toast.success({ message: "预定成功", forbidClick: true });
                        localStorage[searchParamsKey] = JSON.stringify(this.routeQuery);
                        setTimeout(() => {
                            this.$router.push({ path: "/submitSuccess" });
                        }, 1000);
                    } else {
                        this.$toast({ message: res.msg, duration: 2000 });
                    }
                })
                .catch(err => {
                    this.$toast.clear();
                    this.$toast.fail("提交失败");
                });
        },
        selectRoomNum(numIndex) {
            this.routeQuery.roomNum = numIndex + 1;
            this.roomNums = this.roomNums.map(item => ({ ...item, active: false }));
            this.roomNums[numIndex].active = true;
            this.arrowDir = "down";
            let dif = numIndex + 1 - this.cusNames.length;
            if (dif > 0) {
                this.cusNames = [...this.cusNames, ...new Array(dif).fill("")];
            } else if (dif < 0) {
                this.cusNames.splice(numIndex + 1, this.cusNames.length);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.confirmOrder-wrap {
    background-color: #ebeef5;
    height: calc(100vh - 46px - 12vw);
    padding: 3vw;
    box-sizing: border-box;
    overflow-y: scroll;
    > div {
        border-radius: 1.2vw;
        overflow: hidden;
    }
    > div ~ div {
        margin-top: 3vw;
    }
    .process {
        height: 22vw;
        background-color: #fff;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-shrink: 0;
        > div {
            position: relative;
            @extend .flex-column;
            justify-content: center;
            align-items: center;
            color: #6e6e6e;
            font-size: 3.2vw;
            > div:last-child {
                margin-top: 2vw;
            }
        }
        div + div {
            &:before {
                content: "";
                background-color: rgba($color: #bfa66d, $alpha: 0.7);
                width: 7vw;
                height: 0.3vw;
                position: absolute;
                left: -5vw;
                top: 25%;
            }
        }
    }
    .hotelInfo {
        padding: 1.5vw 2.7vw 0;
        box-sizing: border-box;
        background-color: #fff;
        display: flex;
        .date-info {
            padding: 2.5vw 0;
            border-radius: 1vw;
            font-size: 3.2vw;
            .dateArea {
                $dateColor: #bebebe;
                padding-right: 4vw;
                border-right: 1px solid $dateColor;
                .startTime > span:first-child,
                .endTime > span:first-child {
                    font-size: 4.1vw;
                    font-weight: bold;
                    margin-right: 1vw;
                }
                > div:nth-child(2) {
                    padding: 0 1.5vw;
                    border-radius: 2.5vw;
                    border: 1px solid $dateColor;
                    position: relative;
                    &:before,
                    &:after {
                        content: "";
                        width: 1.5vw;
                        height: 1px;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        background-color: $dateColor;
                    }
                    &:before {
                        left: -1.5vw;
                    }
                    &:after {
                        right: -1.5vw;
                    }
                }
            }
            .personNum {
                width: 13vw;
                font-weight: bold;
            }
        }
        .roomTitle {
            font-size: 4vw;
            font-weight: bold;
        }
        .facility {
            margin-top: 2vw;
            .facilityItem {
                display: flex;
                align-items: center;
                flex-wrap: nowrap;
                width: 45%;
                margin-bottom: 3vw;
                > span:last-child {
                    font-size: 3.2vw;
                    margin-left: 1vw;
                    @extend .text-one;
                }
            }
        }
    }
    .notice {
        background-color: #fff;
        padding: 2.7vw;
        .line1 {
            > div:first-child {
                font-weight: bold;
                > span {
                    margin-left: 1vw;
                }
            }
            > div:last-child {
                color: rgb(35, 149, 255);
                &:active {
                    color: rgb(110, 185, 255);
                }
            }
        }
        > div:nth-child(2) {
            padding: 2vw 0 0;
            color: #6e6e6e;
            > ul {
                > li {
                    @extend .text-one;
                    font-size: 3.2vw;
                    &:before {
                        content: "•";
                        font-size: 5vw;
                        margin: 0 2.3vw;
                    }
                }
            }
        }
    }
    .roomInfo {
        background-color: #fff;
        /deep/.van-cell__title {
            font-size: 3.72vw;
            font-weight: bold;
        }
        .roomNum {
            /deep/.van-cell__value {
                flex: 2;
                text-align: left;
                color: #000;
            }
            .roomNumPicker {
                background-color: #f3f5fa;
                height: 12vw;
                transition: height ease 0.3s;
                > div {
                    height: 70%;
                    width: 16%;
                    border-radius: 1vw;
                    background-color: #fff;
                    color: #333;
                }
                .activeItem {
                    background-image: linear-gradient(to right, #ee5d5d, #ff4147);
                    color: #fff;
                }
            }
            .collapsedPicker {
                height: 0;
                transition: height ease 0.3s;
            }
        }
    }
    .importantNotice {
        background-color: #fff;
        overflow: hidden;
        /deep/.van-cell__title {
            font-size: 4.3vw;
            font-weight: bold;
        }
        .iNItem {
            border-bottom: 1px solid #ebedf0;
            /deep/.van-cell__title {
                font-size: 3.72vw;
            }
            .iNItemTitle {
                &::after {
                    display: none;
                }
            }
            .iNItemText {
                color: #6e6e6e;
                font-size: 3.2vw;
                padding-top: 0;
            }
        }
    }
}
.submitSheet {
    height: 12vw;
    padding: 0 6vw;
    > div:first-child {
        color: $primary;
        font-size: 4.5vw;
    }
    .submitBtn {
        padding: 0 10vw;
    }
}
.noticePopTitle {
    position: absolute;
    top: 0;
    width: 100vw;
    $noticePopTitleHeight: 10vw;
    height: $noticePopTitleHeight;
    border-bottom: 1px solid #e6e6e6;
    > div:first-child {
        color: #000;
    }
    > div:last-child {
        position: absolute;
        right: 0;
        width: $noticePopTitleHeight;
        height: $noticePopTitleHeight;
        &:active {
            background-color: rgba(204, 204, 204, 0.1);
        }
    }
}
.noticeItem {
    font-size: 3.2vw;
    padding: 2vw 1.8vw 2vw 0;
    > div:first-child {
        width: 18vw;
        @extend .text-one;
        color: #000;
        font-weight: bold;
        margin-right: 2vw;
        text-align: right;
    }
    > div:last-child {
        flex: 1;
        color: #333;
    }
}
/deep/.van-index-bar__sidebar {
    top: 60%;
}
</style>
